import PropTypes from "prop-types";
import { motion } from "framer-motion";
import "./Square.css";

const Square = ({ ind, updateSquares, clsName }) => {
  console.log("clsName");
  console.log(clsName);
  const handleClick = () => {
    updateSquares(ind);
  };
  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      className="square"
      onClick={handleClick}
    >
      {clsName && (
        <motion.span
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className={clsName}
        ></motion.span>
      )}
    </motion.div>
  );
};

Square.propTypes = {
  ind: PropTypes.string,
  updateSquares: PropTypes.func,
  clsName: PropTypes.string,
};

export { Square };
